import React from 'react';
import { Row } from 'reactstrap';

import AutoRecharge from './AutoRecharge';
import ListMethod from './ListMethod';
import AddPaymentBtn from './AddPaymentBtn';
import AddPaymentDialog from './Dialog/AddPaymentDialog';
import useToggleDialog from 'hooks/useToggleDialog';

const CheckOutForm = ({ disableAutoRecharge }) => {
  //! State
  const [openAddPaymentMethod, toggleAddPaymentMethod, shouldRenderPaymentMethod] =
    useToggleDialog();

  //! Function

  //! Render
  return (
    <div className='checkout-form'>
      {shouldRenderPaymentMethod && (
        <AddPaymentDialog isOpen={openAddPaymentMethod} toggle={toggleAddPaymentMethod} />
      )}
      <Row>
        <AddPaymentBtn onClick={toggleAddPaymentMethod} />
        <ListMethod />
        <AutoRecharge disableAutoRecharge={disableAutoRecharge} />
      </Row>
    </div>
  );
};
export default React.memo(CheckOutForm);
